<template>
    <div>
        <ion-grid>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="search-view">
                <ion-col >
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label>Enter Corpoate Name <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input v-model="corporateName" @ionInput="corporateName = corporateName.toUpperCase()" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="3">
                            <ion-label>Effective From</ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class="form-vue-picker"
                                    placeholder="DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model="effectiveFrom"
                                    :typeable="true"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <datepicker
                                    class= "form-picker"
                                    placeholder= "Select From Date"
                                    inputFormat="MMM dd, yyyy"
                                    v-model= "effectiveFrom"
                                    :typeable= "true"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col> -->
                        <!-- <ion-col size="12" size-md="3">
                            <ion-label>Effective To</ion-label>
                            <div class="date-picker-box margin-top-10 datepicker-web">
                                <datepicker
                                    class="form-vue-picker"
                                    placeholder="DD/MON/YYYY"
                                    inputFormat="dd/MMM/yyyy"
                                    v-model="effectiveTo"
                                    :typeable="true"
                                ></datepicker>
                                <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                            <div class="border-line-34 margin-top-10 datepicker-mobile">
                                <datepicker
                                class= "form-picker"
                                placeholder= "Select To Date"
                                inputFormat="MMM dd, yyyy"
                                v-model= "effectiveTo"
                                :typeable= "true"
                                ></datepicker>
                                <span class="input-icon-calendar">
                                <img src="/../assets/images/common/datepicker/calendar.png" />
                                </span>
                            </div>
                        </ion-col> -->
                        <ion-col size="12" size-md="3">
                            <ion-label>Status <span class="required">*</span></ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select 
                                    v-model="status" 
                                    :value="status"
                                    @ionChange="status = $event.target.value"
                                    class="form-select select-mobile"
                                    placeholder="Select Status"
                                    interface="action-sheet">
                                    <ion-select-option
                                        v-for="item in statusOptions"
                                        :key="item.code"
                                        :value="item.code"
                                    >
                                        {{ item.description }}
                                    </ion-select-option>
                                </ion-select>
                                <select
                                    class="input-select select-web"
                                    v-model="status"
                                    placeholder="Select Status"
                                    >
                                    <option
                                    v-for="item in statusOptions"
                                        :key="item.code"
                                        :value="item.code"
                                    >{{ item.description }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <!-- <ion-col></ion-col> -->
                        <ion-col size="12" size-md="3">
                            <br />
                            <ion-button class="btn-add btn-search margin-top-10" @click="addCorporate">{{ isEditing ? "Update" : "Add Corporate" }}</ion-button>
                            <ion-button class="btn-cancel btn-search margin-top-10" @click="cancel">Cancel</ion-button>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            
        </ion-grid>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonLabel, IonRow, IonInput, IonSelect, IonSelectOption } from "@ionic/vue";
import datepicker from 'vue3-datepicker';
import { ToastUtils } from "../../util/toast-utils";
import { AdminService } from "@/service/admin/admin.service";
import { migratedTryParseServiceError } from "../../service";

export default defineComponent({
    name: 'AddNewCorporate',
    components:{
        IonGrid, IonRow, IonCol, IonButton, IonLabel, IonInput, datepicker, IonSelect, IonSelectOption
    },
    data(){
        return{
            corporateName: "",
            effectiveFrom: "",
            effectiveTo: "",
            status: "",
            statusOptions: [],
            // "statusOptions": [
            //     {
            //     "discription": "Active",
            //     "code": "A"
            //     },
            //     {
            //     "discription": "Inactive",
            //     "code": "I"
            //     }
            // ],
            isEditing : false,
            corporateId: null,
        }
    },
    async mounted() {
        this.statusOptions = await new AdminService().getCorporateStatus();
        const editData = localStorage.getItem("corporateDetails");

        if (editData) {
            const data = JSON.parse(editData);
            this.corporateId = data.corporateId; 
            this.corporateName = data.corporateName;
            this.status = data.status.code;

            this.isEditing = true;
        }
    },
    methods: {
        async addCorporate() {
            if (
                typeof this.corporateName === "undefined" ||
                this.corporateName === null ||
                this.corporateName === "" || 
                (this.corporateName).toString().trim().length === 0
            ) {
                new ToastUtils().presentToast("Enter Corporate Name");
            } else if( typeof this.status === "undefined" ||
                this.status === null ||
                this.status === "" || 
                this.status.trim().length === 0
            ) {
                new ToastUtils().presentToast("Select Status");
            } else {
                // const payload = {
                //     corporateName: this.corporateName,
                //     status: this.status
                // };

                try {
                    let result;

                    if (this.isEditing) {
                        result = await new AdminService().updateCorporate(
                            (this.corporateName).toString().trim(),
                            this.status,
                            this.corporateId
                        );
                        this.$router.push("CorporateNameList");
                        localStorage.removeItem("corporateDetails");
                        localStorage.removeItem("editIndex");
                    } else {
                        try {
                            result = await new AdminService().addCorporate(
                                (this.corporateName).toString().trim(),
                                this.status
                            );
                            if (result?.data?.success) {
                                new ToastUtils().presentToast(result?.data?.message);
                                this.$router.push("CorporateNameList");
                                localStorage.removeItem("corporateDetails");
                                localStorage.removeItem("editIndex");
                            } 
                        } catch(error) {
                            let serviceError = migratedTryParseServiceError(error);
                            new ToastUtils().presentToast(serviceError.description);
                        }
                        
                    }
                    
                    

                    

                } catch (error) {
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
            }
        },

        cancel() {
            this.$router.back();
            localStorage.removeItem("corporateDetails");
            localStorage.removeItem("editIndex");
        },
    }
})
</script>

<style scoped>
.container-div{
    /* width: 30%; */
    margin-top: 20px;
    border: 2px solid rgb(240, 236, 236);
    border-radius: 20px;
    box-shadow: 2px 2px rgb(70, 68, 68);
    
}
.usage-txt{
    font-size: 22px;
    text-align: center;
}
.report-list{
    margin: 80px 0 0 0;
}
.edit-payment {
  font-size: 17px;
  /* margin-left: 2px; */
  cursor: pointer;
}
.btn-add {
    --background: #21b24b 0% 0% no-repeat padding-box;
}
.btn-cancel {
    --background: #8c8b8b 0% 0% no-repeat padding-box;
}
</style>